import {
  getExam,
  getCategory,
  createExam,
  updateExam,
  deleteExam,
  getAutoExam,
  getInfoExam,
  getInfoAdminExam,
  paymentvnpay,
  paymentmomo,
  getExamInCart,
  addExamToCard,
  getResponePayment,
  deleteExamInCard,
  getListExamPaper,
  submitExam,
  getSubmitDetail,
  markWritingQues,
  getListStudentInExam,
  getSubmitExam,
  exportExam, getTransferExam,
  getDataAnalysisExam,

  exportStudentResult,
  getListExams,
  getHSATopics,
  getScienceExam,
  getHsaExamResults

} from "./../api.js";

export const state = {
    exam: {},
    examInfoRes: {},
    adminExamInfoRes:{},
    createExamResponse: {},
    editExamRes: {},
    delExamRes: {},
    pagination: {},
    examAutoRes: {},
    linkPaymentVNPay: {},
    linkPaymentMoMo: {},
    examInCart: {},
    paymentResponse: {},
    deleteExamInCart: {},
    listExamPaper: {},
    submitExamRes:{},
    markWritingRes:{},
    submitDetailRes:{},
    listStudentInExam:{},
    getSubmitExamRes:{},
    responseExam: '',
    transferRes: {},
    dataAnalysisExam: '',
    statusExport: null,
    listExams: {},
    topicInfoRes: {},
    newScienceExam: {},
    hsaExamResults: {}
};

export const getters = {
    exam: state =>
        state.exam ? state.exam.data : [],
    examInfoRes: state =>
        state.examInfoRes ? state.examInfoRes.data : [],
    adminExamInfoRes: state =>
        state.adminExamInfoRes ? state.adminExamInfoRes.data : [],
    pagination: state =>
        state.pagination ? state.pagination : [],
    category: (state) => state.category,
    createExamResponse: state =>
        state.createExamResponse ? state.createExamResponse.data : [],
    editExamRes: state =>
        state.editExamRes ? state.editExamRes.data : [],
    delExamRes: state =>
        state.delExamRes ? state.delExamRes.data : [],
    examAutoRes: state =>
        state.examAutoRes ? state.examAutoRes.data : [],
    linkPaymentVNPay: state =>
        state.linkPaymentVNPay ? state.linkPaymentVNPay.data : [],
    linkPaymentMoMo: state =>
        state.linkPaymentMoMo ? state.linkPaymentMoMo.data : [],
    examInCart: state =>
        state.examInCart ? state.examInCart.data : [],
    paymentResponse: state =>
        state.paymentResponse ? state.paymentResponse : [],
    deleteExamInCart: state =>
        state.deleteExamInCart ? state.deleteExamInCart : [],
    listExamPaper: state =>
        state.listExamPaper ? state.listExamPaper : [],
    listStudentInExam: state =>
        state.listStudentInExam ? state.listStudentInExam : [],
    submitExamRes: state =>
        state.submitExamRes ? state.submitExamRes.data : [],
    markWritingRes: state =>
        state.markWritingRes ? state.markWritingRes.data : [],
    submitDetailRes: state =>
        state.submitDetailRes ? state.submitDetailRes.data : [],
    getSubmitExamRes: state =>
        state.getSubmitExamRes ? state.getSubmitExamRes : [],
    responseExam: state =>
        state.responseExam ? state.responseExam.data : [],
    transferRes: state =>
        state.transferRes ? state.transferRes.data : [],
    dataAnalysisExam : state =>
        state.dataAnalysisExam ? state.dataAnalysisExam.data : [],
    statusExport : state =>
        state.statusExport ? state.statusExport : null,
    listExams: state =>
        state.listExams ? state.listExams : [],
    topicInfoRes: state =>
        state.topicInfoRes ? state.topicInfoRes.data : [],
    newScienceExam: state =>
        state.newScienceExam ? state.newScienceExam.data : [],
    hsaExamResults: state =>
        state.hsaExamResults ? state.hsaExamResults.data : [],
};

export const mutations = {
    setExam(state, data) {
        state.exam = data;
    },
    setCategory(state, data) {
        state.category = data.category.data;
    },
    create(state, data) {
        if (!data.error) {
            state.createExamResponse = data;
        } else {
            state.createExamResponse = data.error.response.data;
        }
    },
    edit(state, data) {
        if (!data.error) {
            state.editExamRes = data;
        } else {
            state.editExamRes = data.error.response.data;
        }
    },
    del(state, data) {
        if (!data.error) {
            state.delExamRes = data;
        } else {
            state.delExamRes = data.error.response.data;
        }
    },
    getAuto(state, data) {
        if (!data.error) {
            state.examAutoRes = data;
        } else {
            state.examAutoRes = data.error.response.data.code;
        }
    },
    getInfoExam(state, data) {
        if (!data.error) {
            state.examInfoRes = data;
        } else {
            state.examInfoRes = data.error.response.data.code;
        }
    },
    getInfoAdminExam(state, data) {
        if (!data.error) {
            state.adminExamInfoRes = data;
        } else {
            state.adminExamInfoRes = data.error.response.data.code;
        }
    },
    getSubmitDetail(state, data) {
        if (!data.error) {
            state.submitDetailRes = data;
        } else {
            state.submitDetailRes = data.error.response.data.code;
        }
    },
    getpaymentVNPay(state, data) {
        if (!data.error) {
            state.linkPaymentVNPay = data;
        } else {
            state.linkPaymentVNPay = data.error.response.data.code;
        }
    },
    getpaymentMomo(state, data) {
        if (!data.error) {
            state.linkPaymentMoMo = data;
        } else {
            state.linkPaymentMoMo = data.error.response.data.code;
        }
    },
    getExamInCart(state, data) {
        if (!data.error) {
            state.examInCart = data;
        } else {
            state.examInCart = data.error.response.data.code;
        }
    },
    addExamToCard(state, data) {
        if (!data.error) {
            state.examInCart = data;
        } else {
            state.examInCart = data.error.response.data.code;
        }
    },
    getPaymentResponse(state, data) {
        if (!data.error) {
            state.paymentResponse = data;
        } else {
            state.paymentResponse = data.error.response.data.code;
        }
    },
    deleteExamInCartRes(state, data) {
        if (!data.error) {
            state.deleteExamInCart = data;
        } else {
            state.deleteExamInCart = data.error.response.data.code;
        }
    },
    submit(state, data) {
        if (!data.error) {
            state.submitExamRes = data;
        } else {
            state.submitExamRes = data.error.response.data.code;
        }
    },
    markWriting(state, data) {
        if (!data.error) {
            state.markWritingRes = data;
        } else {
            state.markWritingRes = data.error.response.data;
        }
    },
    listExamPaper(state, data) {
        if (!data.error) {
            state.listExamPaper = data;
        } else {
            state.listExamPaper = data.error.response.data.code;
        }
    },
    listStudentInExam(state, data) {
        if (!data.error) {
            state.listStudentInExam = data.data;
        } else {
            state.listStudentInExam = data.error.response.data.code;
        }
    },
    pagination(state, data) {
        if (!data.error) {
            state.pagination = data;
        } else {
            state.pagination = data.error.response.data.code;
        }
    },
    getSubmitExam(state, data) {
        if (!data.error) {
            state.getSubmitExamRes = data;
        } else {
            state.getSubmitExamRes = data.error.response.data.code;
        }
    },
    getResponseExam(state, data) {
        if (!data.error) {
            state.responseExam = data.data;
        } else {
            state.responseExam = data.error.response.data;
        }
    },
    getTransferExam(state, data) {
        if(!data.error){
          state.transferRes = data.data
        } else {
          state.transferRes = data.error.response.data
        }
    },
    mutationDataAnalysisExam(state, data){
        state.dataAnalysisExam = data;
    },
    mutationStatusExport(state, data){
        state.statusExport = data;
    },

    setListExams(state, data) {
        state.listExams = data;
    },

    // begin: hsa vnu for sangsang
    getHSATopics(state, data) {
        if (!data.error) {
            state.topicInfoRes = data;
        } else {
            state.topicInfoRes = data.error.response.data.code;
        }
    },
    getNewScienceExam(state, data) {
        if (!data.error) {
            state.newScienceExam = data;
        } else {
            state.newScienceExam = data.error.response.data.code;
        }
    },
    mutaHsaExamResults(state, data) {
        if (!data.error) {
            state.hsaExamResults = data;
        } else {
            state.hsaExamResults = data.error.response.data.code;
        }
    },
    // end: hsa vnu for sangsang
};

export const actions = {
    async getExam({commit}, query) {
        let data = await getExam(query);
        commit("setExam", data.data);
        commit("pagination", data.data);
    },
    async getInfoExam({commit}, id) {
        let data = await getInfoExam(id);
        commit("getInfoExam", data);
    },
    async getInfoAdminExam({commit}, id) {
        let data = await getInfoAdminExam(id);
        commit("getInfoAdminExam", data);
    },
    async getSubmitDetail({commit}, id) {
        let data = await getSubmitDetail(id);
        commit("getSubmitDetail", data);
    },
    async getCategory({commit}) {
        const category = await getCategory();
        commit("setCategory", {category: category});
    },
    async create({commit}, query) {
        let data = await createExam(query);
        commit("create", data);
    },
    async edit({commit}, query) {
        let data = await updateExam(query);
        commit("edit", data);
    },
    async del({commit}, id) {
        let data = await deleteExam(id);
        commit("del", data);
    },
    async getAuto({commit}, query) {
        let data = await getAutoExam(query);
        commit("getAuto", data);
    },
    async getpaymentVNPay({commit}, query) {
        let data = await paymentvnpay(query);
        commit("getpaymentVNPay", data);
    },
    async getpaymentMomo({commit}, query) {
        let data = await paymentmomo(query);
        commit("getpaymentMomo", data);
    },
    async getExamInCart({commit}, id) {
        let data = await getExamInCart(id);
        commit("getExamInCart", data);
    },
    async addToCard({commit}, query) {
        let data = await addExamToCard(query);
        commit("addExamToCard", data);
    },
    async getPaymentResponse({commit}, params) {
        let data = await getResponePayment(params);
        commit("getPaymentResponse", data);
    },
    async deleteExamInCart({commit}, params) {
        let data = await deleteExamInCard(params);
        commit("deleteExamInCartRes", data);
    },
    async submit({commit}, query) {
        let data = await submitExam(query);
        commit("submit", data);
    },
    async markWriting({commit}, query) {
        let data = await markWritingQues(query);
        commit("markWriting", data);
    },
    async getListExamPaper({commit}, params) {
        let data = await getListExamPaper(params);
        commit("listExamPaper", data);
        commit("pagination", data);
    },
    async getListStudentInExam({commit}, params) {
        let data = await getListStudentInExam(params);
        commit("listStudentInExam", data);
    },
    async getSubmitExam({commit}, query) {
        let data = await getSubmitExam(query);
        //console.log(data);
        commit("getSubmitExam", data);
        commit("pagination", data);
    },
    async exportExam({ commit }, params){
        let isSuccess = await exportExam(params);
        commit("getResponseExam", isSuccess);
    },
    async getTransferExam({ commit }, params){
        let isSuccess = await getTransferExam(params);
        commit("getTransferExam", isSuccess);
    },
    async actionDataAnalysisExam({ commit }, params){
        let isSuccess = await getDataAnalysisExam(params);
        commit("mutationDataAnalysisExam", isSuccess);
    },
    async exportStudentResult({ commit }, params) {
        let isSuccess = await exportStudentResult(params);
       // console.log(isSuccess);
        commit("mutationStatusExport", isSuccess);
      },

    async getListExams({commit}, query) {
        let data = await getListExams(query);
        commit("setListExams", data.data);
    },
    // begin: hsa vnu for sangsang
    async getHSATopics({commit}, id) {
        let data = await getHSATopics(id);
        commit("getHSATopics", data);
    },
    async submitSelectedScience({commit}, id) {
        let data = await getScienceExam(id);
        commit("getNewScienceExam", data);
    },
    async submitHsaExamResults({commit}, id) {
        let data = await getHsaExamResults(id);
        commit("mutaHsaExamResults", data);
    },
    // end: hsa vnu for sangsang
};
